<div class="menu-filter">
  <input
    type="text"
    class="menu-filter-input"
    [ngClass]="[bordered ? '_bordered-search' : '', searchQuery ? '_active' : '', searchQuery && !filteredItems.length ? '_error' : '']"
    [(ngModel)]="searchQuery"
    (ngModelChange)="onSearchChange()"
    />
    <i class="search-i"></i>
    @if (!searchQuery) {
      <span class="menu-filter-placeholder">{{ caption | translate }}</span>
    }
  </div>
